(function initArticlePage() {
  "use strict";

  document.querySelectorAll("[data-article-slider]").forEach((slider) => {
    const viewport = slider.querySelector(".article-slider__viewport");
    const slides = [...slider.querySelectorAll("[data-article-slide]")];
    const count = slider.querySelector("[data-slider-count]");
    const nextButton = slider.querySelector("[data-slider-next]");
    let active = 0;
    let pointerStart = null;

    function show(index) {
      active = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const selected = slideIndex === active;
        slide.classList.toggle("is-active", selected);
        slide.setAttribute("aria-hidden", String(!selected));
      });
      count.textContent = `${String(active + 1).padStart(2, "0")} / ${String(slides.length).padStart(2, "0")}`;
      slider.style.setProperty("--slider-progress", `${((active + 1) / slides.length) * 100}%`);
    }

    nextButton.addEventListener("click", () => show(active + 1));
    viewport.addEventListener("keydown", (event) => {
      if (event.key === "ArrowRight") show(active + 1);
      if (event.key === "ArrowLeft") show(active - 1);
    });
    viewport.addEventListener("pointerdown", (event) => {
      pointerStart = event.clientX;
      viewport.setPointerCapture?.(event.pointerId);
    });
    viewport.addEventListener("pointerup", (event) => {
      if (pointerStart === null) return;
      const distance = event.clientX - pointerStart;
      pointerStart = null;
      if (Math.abs(distance) < 32) return;
      show(active + (distance < 0 ? 1 : -1));
    });
    viewport.addEventListener("pointercancel", () => { pointerStart = null; });
    show(0);
  });

  const terrains = [
    ["SURFACE 01 / 03", "CITY", "ASPHALT / TOKYO"],
    ["SURFACE 02 / 03", "GRAVEL", "LOOSE STONE / BETWEEN"],
    ["SURFACE 03 / 03", "WILD", "EARTH / KENYA"]
  ];

  document.querySelector("[data-stage]")?.addEventListener("gravel:phase", ({ detail }) => {
    const [number, name, note] = terrains[detail.phase];
    const terrainName = document.querySelector(".terrain-name");
    if (terrainName) {
      terrainName.querySelector("small").textContent = number;
      terrainName.querySelector(".terrain-name__title").textContent = name;
      terrainName.querySelector(".terrain-name__title + p").textContent = note;
    }
    document.querySelectorAll("[data-surface]").forEach((item, index) => item.classList.toggle("is-active", index === detail.phase));
  });
})();
